var _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSubtract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m.393 10.121 9.97-9.97h5.515L18.9 3.17v5.415L8.88 18.606.392 10.122Zm12.021-3.535a2 2 0 1 0 2.828-2.828 2 2 0 0 0-2.828 2.828Z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m.393 10.121 9.97-9.97h5.515L18.9 3.17v5.415L8.88 18.606.392 10.122Zm12.021-3.535a2 2 0 1 0 2.828-2.828 2 2 0 0 0-2.828 2.828Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.364.15v-1H9.95l-.293.294.707.707Zm-9.97 9.971-.708-.707-.707.707.707.708.707-.708ZM15.877.151l.708-.707-.293-.293h-.415v1ZM18.9 3.17h1v-.414l-.293-.292-.707.707Zm0 5.415.707.707L19.9 9v-.414h-1ZM8.88 18.606l-.708.708.707.707.708-.707-.708-.707ZM9.656-.555l-9.97 9.97L1.1 10.83 11.07.858 9.658-.556Zm6.221-.293h-5.514v2h5.514v-2Zm3.728 3.314-3.02-3.021L15.17.858l3.021 3.02 1.414-1.413Zm.293 6.121V3.172h-2v5.414h2ZM9.586 19.314l10.02-10.02-1.414-1.415-10.02 10.02 1.414 1.415Zm-9.9-8.485 8.485 8.485L9.586 17.9 1.1 9.414-.314 10.83Zm14.85-4.95a1 1 0 0 1-1.415 0l-1.414 1.414a3 3 0 0 0 4.242 0L14.536 5.88Zm0-1.414a1 1 0 0 1 0 1.414l1.414 1.414a3 3 0 0 0 0-4.243l-1.415 1.415Zm-1.415 0a1 1 0 0 1 1.414 0L15.95 3.05a3 3 0 0 0-4.243 0l1.414 1.415Zm0 1.414a1 1 0 0 1 0-1.414L11.707 3.05a3 3 0 0 0 0 4.243l1.414-1.414Z",
    mask: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubtract);
export default __webpack_public_path__ + "static/media/icon-subtract.e71627dd1446cf31a5054b1b21c9e711.svg";
export { ForwardRef as ReactComponent };